// Coordinatore "audio focus" dei video (landing): al massimo UN video con audio in
// riproduzione alla volta. Quando un player diventa udibile, gli altri ricevono `yield`
// (pausa + muto, posizione conservata). Modulo puro, zero dipendenze: testabile in isolamento.

type YieldFn = () => void;

const players = new Map<string, YieldFn>();
let activeId: string | null = null;

// Registra un player e la sua azione di resa. Ritorna l'unregister.
export function register(id: string, yieldFn: YieldFn): () => void {
  players.set(id, yieldFn);
  return () => {
    players.delete(id);
    if (activeId === id) activeId = null;
  };
}

// Un player diventa attivo (udibile): se un altro era attivo, lo mette in resa, poi prende il focus.
export function requestFocus(id: string): void {
  if (activeId && activeId !== id) {
    const yieldFn = players.get(activeId);
    if (yieldFn) {
      try { yieldFn(); } catch { /* un player che fallisce non deve bloccare gli altri */ }
    }
  }
  activeId = id;
}

// Rilascia il focus solo se era questo il player attivo (evita race con l'unregister).
export function releaseFocus(id: string): void {
  if (activeId === id) activeId = null;
}

// Solo per i test.
export function _reset(): void {
  players.clear();
  activeId = null;
}

export function _activeId(): string | null {
  return activeId;
}
